// These should match the categories
// in ingredients.js & cocktails.js

const categories = {
  amaro: "amaro",
  liqueur: "liqueur",
  aperitif: "aperitif",
  rum: "rum",
  brandy: "brandy",
  whiskey: "whiskey",
  cognac: "cognac",
  vodka: "vodka",
  gin: "gin",
  mezcal: "mezcal",
  tequila: "tequila",
  absinthe: "absinthe",
  vermouth: "vermouth",
  cachaca: "cachaca", //
  pisco: "pisco", //
  sparklingWine: "sparkling wine",
  sherry: "sherry", //
  sake: "sake",
  lemonJuice: "lemon juice", //
  limeJuice: "lime juice", //
  orangeJuice: "orange juice", //
  peachPuree: "peach puree", //
  cranberryJuice: "cranberry juice", //
  cola: "cola", //
  gingerAle: "ginger ale", //
  gingerBeer: "ginger beer", //
  grapefruitSoda: "grapefruit soda", //
  tonicWater: "tonic water", //
  clubSoda: "club soda", //
  seltzer: "seltzer",
  nonalchoholic: "nonalchoholic",
}

export default categories
